export default ['mintegral_ad_account', 'mediago_ad_account', 'pinterest_ad_account']
